

'use strict';

export default function setupStockNotificationForm () {
    const holder = document.querySelector('.stock-notification-holder');

    if ( holder ) {

        const toggleBtn = holder.querySelector('.toggle-notification-form');
        const notification = holder.querySelector('.form-notification');
        const form = holder.querySelector('.stock-notification-form');
        const input = form.querySelector('input[name="email"]');

        toggleBtn.addEventListener('click', () => {
            if ( input ) {
                form.classList.toggle('active');

                input.focus();
            } else {
                addStockNotifiction();
            }
        });


        form.addEventListener('submit', evt => {
            evt.preventDefault();

            addStockNotifiction();
        });


        function addStockNotifiction () {
            const formData = new FormData(form);

            fetch(
                '/api/product/addStockNotifiction',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(Object.fromEntries(formData.entries())),
                }
            )
            .then(response => {
                if ( response.ok ) {
                    notification.classList.remove('error');
                    form.remove();
                    toggleBtn.remove();
                } else {
                    notification.classList.add('error');
                }

                return response.json();
            })
            .then(response => {
                notification.innerHTML = response.message;
            });
        }
    }
}
